import React from 'react'
import Index from './Pages/Index'
import Contact from './Pages/Contact'
import About from './Pages/About'
import Services from './Pages/Services'
import Header from './Pages/Header'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Herosection from './Pages/Herosection'
import Footer from './Pages/Footer'
import Hea from './Pages/Hea'
import Contact1 from './Pages/Contact1'
import Footergpt from './Pages/Footergpt'
import Yearsexp from './Pages/Yearsexp'
import CIJ from './Pages/CIJ'
import ProductDetails from './Pages/ProductDetails'
import ProductCarousel from './Pages/ProductCarousel'
import I9std from './Pages/I9std'
import I9micro from './Pages/I9micro'
import I9hrs from './Pages/I9hrs'
import LT910 from './Pages/LT910'
import LT900 from './Pages/LT900'
import LT980 from './Pages/LT980'
import LT880 from './Pages/LT880'
import LT800 from './Pages/LT800'
import LT810pro from './Pages/LT810pro'
import ResponsiveSidebar from './Pages/ResponsiveSidebar'
import TIJLayout from './Pages/TIJLayout'
import TTOLayout from './Pages/TTOLayout'
import Laserlayout from './Pages/Laserlayout'
import TabNavigation from './Pages/TabNavigation'
import RetailWeighingLayout from './Pages/RetailWeighingLayout'
import Dibal500 from './Pages/Dibal500'
import Dibal900 from './Pages/Dibal900'
import Dibalpcscale from './Pages/Dibalpcscale'
import Dibalwind from './Pages/Dibalwind'
import Rongta from './Pages/Rongta'
import BarcodePrinters from './Pages/BarcodePrinters'
import BarcodeLayout from './Pages/BarcodeLayout'
import IndustrialScalesPage from './Pages/IndustrialScalesPage'
import IndustrialScales from './Pages/IndustrialScales'
import Header1 from './Pages/Header1'
import Headerclaude from './Pages/Headerclaude'
import Sunmiclaude from './Pages/Sunmiclaude'
import HandshowESL from './Pages/HandshowESL'
import Hanshowclaude from './Pages/Hanshowclaude'
import Concealedclaude from './Pages/Concealedclaude'
import Concealeddeep from './Pages/Concealeddeep'
import Underconstruction from './Pages/Underconstruction'
import Underconstructionesl from './Pages/Underconstructionesl'
import ESLProductCatalog from './Pages/ESLProductCatalog'
import Mobilesecurity from './Pages/Mobilesecurity'
import ProductCatalogMobile from './Pages/ProductCatalogMobile'
import ContactFormWithCaptcha from './Pages/ContactFormWithCaptcha'
import AIScale from './Pages/AIScale'


function App() {
  return (
    <div style={{ margin: 0, padding: 0 }}>
      <BrowserRouter>
        <Header/>

        <Routes>
            <Route path='/concealedclaude' element={<Concealedclaude/>}></Route>
            <Route path='/concealeddeep' element={<Concealeddeep/>}/>
            <Route path='/' element={<Herosection/>}></Route>
            <Route path='/about-us' element={<About/>}></Route> 
           <Route path='/services' element={<Services/>}></Route>
            <Route path='/contact-us' element={<Contact1/>}></Route>
            <Route path='/years' element={<Yearsexp/>}></Route>
            <Route path='/continuous-inkjet-printer' element={<CIJ/>}></Route>
            <Route path='/LT860' element={<ProductDetails/>}></Route>
            
            <Route path='/I9std' element={<I9std/>}></Route>
            <Route path='/I9micro' element={<I9micro/>}></Route>
            <Route path='/I9hrs' element={<I9hrs/>}></Route>
            <Route path='/LT910' element={<LT910/>}></Route>
            <Route path='/LT900' element={<LT900/>}></Route>
            <Route path='/LT980' element={<LT980/>}></Route>
            <Route path='/LT880' element={<LT880/>}></Route>
            <Route path='/LT800' element={<LT800/>}></Route>

            
            <Route path='/LT810pro' element={<LT810pro/>}></Route>
            {/* <Route path='/thermal-inkjet-printers/ZH' element={<ResponsiveSidebar mode="ZH"/>}></Route>
            <Route path='/thermal-inkjet-printers/ZX1' element={<ResponsiveSidebar mode="ZX1"/>}></Route>
            <Route path='/thermal-inkjet-printers/ZX2' element={<ResponsiveSidebar mode="ZX2"/>}></Route>
            <Route path='/thermal-inkjet-printers/ZX4' element={<ResponsiveSidebar mode="ZX4"/>}></Route>
            <Route path="/tij/*" element={<TIJLayout />} /> */}
            <Route path="/thermal-inkjet-printer" element={<TIJLayout mode="hand-held-printer" />} />
            <Route path="/thermal-inkjet-printer/:type" element={<TIJLayout />} />
            <Route path="/thermal-transfer-printer" element={<TTOLayout mode="32I&C-TTO" />} />
            <Route path="/thermal-transfer-printer/:type" element={<TTOLayout />} />
            <Route path="/laser-printer" element={<Laserlayout mode="laser-co2-printers" />} />
            <Route path="/laser-printer/:type" element={<Laserlayout />} />

            <Route path="/eas-system" element={<TabNavigation/>}></Route>

            <Route path="/laser-printer" element={<Laserlayout mode="laser-co2-printers" />} />
            <Route path="/laser-printer/:type" element={<Laserlayout />} />

            
        {/* Main layout route with nested routes */}
        <Route path="/retail-scales" element={<RetailWeighingLayout/>}>
          {/* Default route when no type is specified */}
          <Route index element={<Dibal500/>} />
          
          {/* ZH category routes with subcategories */}
          <Route path="Dibal-scales">
            <Route index element={<Dibal500/>} />
            <Route path="Dibal-500" element={<Dibal500/>} />
            <Route path="Dibal-900" element={<Dibal900/>} />
            <Route path="Dibal-pcscales" element={<Dibalpcscale/>} />
            <Route path="Dibal-windseries" element={<Dibalwind/>} />
          </Route>
          
          {/* ZX category route (no subcategories) */}
          <Route path="Rongta-scales" element={<Rongta/>} />
          <Route path="AI-Scales" element={<AIScale/>}/>
        </Route>
          <Route path="/barcode-products" element={<BarcodeLayout mode="type1"/>}></Route>
          <Route path="/barcode-products/:type" element={<BarcodeLayout/>} />
          <Route path='/industrial' element={<IndustrialScalesPage/>}></Route>
          <Route path='/industrial-weighing-scales' element={<IndustrialScales/>}></Route>
          <Route path='/sunmi-pos' element={<Sunmiclaude/>}></Route>
          <Route path='/hanshow' element={<HandshowESL/>}></Route>
          
          <Route path='/packaging-machines' element={<Underconstruction/>}></Route>
          <Route path='/electronic-shelf-label' element={<Hanshowclaude/>}></Route>
          <Route path='/mobilesecurity' element={<Mobilesecurity/>}></Route>
          <Route path='/catalog' element={<ProductCatalogMobile/>}></Route>
          <Route path='/captcha' element={<ContactFormWithCaptcha/>}></Route>
        </Routes>
        
        <Footergpt/>
      </BrowserRouter>
      

      

    </div>
  )
}

export default App
